import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=084c5ac8&"
import script from "./sidebar.vue?vue&type=script&lang=js&"
export * from "./sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/borno-cct/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('084c5ac8')) {
      api.createRecord('084c5ac8', component.options)
    } else {
      api.reload('084c5ac8', component.options)
    }
    module.hot.accept("./sidebar.vue?vue&type=template&id=084c5ac8&", function () {
      api.rerender('084c5ac8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/layouts/sidebar.vue"
export default component.exports